import React from "react"
import { useNavigate } from "react-router-dom";

interface StartCardProps {
    src: string,
    title: string,
    text: string,
    alt: string
}

export const StartCard: React.FC<StartCardProps> = ({ src, text, title , alt }) => {
    const navigate = useNavigate();
    return (
        <div className="flex flex-col mb-8">
            <h3 onClick={() => { navigate('/nido')}} className="cursor-pointer primaryFont font-semibold text-2xl md:text-xl underline">{title}</h3>
            <div className="mt-16 flex items-start gap-4">
                <div className="w-[69px] flex-shrink-0">
                    <img className="w-full h-full object-cover" src={src} alt={alt} />
                </div>
                <p className="secondaryFont text-[#575757] text-2xl md:text-xl">{text}</p>
            </div>
        </div>
    )
}
